import React, {useCallback} from 'react';
import AutocompleteInput from '../../../../../../../AutocompleteInput';

function TextInputValue(props) {
    const {operator, value, onChange} = props,
        {fetchSuggestions} = operator;

    const handleInputChange = useCallback(event => onChange(event.target.value), [onChange]);

    if (fetchSuggestions) {
        return <AutocompleteInput value={value} onChange={onChange} fetchSuggestions={fetchSuggestions} />;
    }

    return <input type="text" className="form-control" value={value} onChange={handleInputChange} />;
}

export default TextInputValue;
